import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const CreateUser = async (gidecekData) => {
  return await axios.post(url + "register", gidecekData);
};
